<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h2>{{ $t('brands.brands') }}</h2>
        <brands-table-component></brands-table-component>
    </layout-authenticated>
</template>

<script>
import BrandsTableComponent from "@/components/admin/tables/BrandsTableComponent";
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";

export default {
    name: 'Brands',
    components: {LayoutAuthenticated, BrandsTableComponent},
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.administration'),
                    href: '/admin'
                },
                {
                    text: this.$t('brands.brands'),
                    href: '/admin/brands',
                    disabled: true
                }
            ];
        }
    }
}
</script>
